/* RESPONSIBLE TEAM: team-actions */
import SettingsRoute from 'embercom/routes/apps/app/settings/base/base-settings-route';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'ember-intl/services/intl';
import type SetupAction from 'embercom/models/workflow-connector/setup-action';
import type McpServer from 'embercom/models/workflow-connector/mcp-server';
import type ArrayProxy from '@ember/array/proxy';

export default class CustomActions extends SettingsRoute {
  @service declare store;
  @service declare appService: $TSFixMe;
  @service declare intercomEventService;
  @service declare permissionsService: $TSFixMe;
  @service declare intl: IntlService;

  analytics = {
    section: 'settings',
    place: 'action-builder',
  };

  get titleToken() {
    return this.intl.t('new-settings.app-settings.custom-actions.action-builder-title');
  }

  async model() {
    let actions: ArrayProxy<SetupAction> = await this.store.findAll(
      'workflow-connector/setup-action',
    );
    let mcpServers: ArrayProxy<McpServer> = this.appService.app.canUseMcpActions
      ? await this.store.findAll('workflow-connector/mcp-server')
      : ([] as unknown as ArrayProxy<McpServer>);

    if (!actions) {
      return {
        actions: [],
        templateActions: [],
        mcpServers,
      };
    }

    let workflowActions = actions.filterBy('isTemplate', false);
    let templateActions = actions.filterBy('isTemplate', true);

    return {
      actions: workflowActions,
      templateActions,
      mcpServers,
    };
  }

  @action
  didTransition() {
    super.didTransition();
    this.intercomEventService.trackEvent('has_visited_custom_actions');
  }
}
